import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-sponsor-application',
  templateUrl: './sponsor-application.component.html',
  styleUrls: ['./sponsor-application.component.css']
})
export class SponsorApplicationComponent implements OnInit {
	
  public pageName: string = "sponsor-application";
  public errorMessage: string;
  public successMessage: string;

  public locations = [
    'Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo', 
    'Mpumalanga', 'North West', 'Northern Cape', 'Western Cape'
  ];

  public categories = [
    'Banking', 'Insurance', 'Government', 'Sport', 'technology', 'Energy', 'Telecommunication', 
    'Sport Wear', 'Hospitality', 'Beverages', 'Transport', 'Education'
  ]

  public months = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 
    'September', 'October', 'November', 'December'
  ]

  applicationForm: FormGroup;

  constructor(private fb: FormBuilder) { 
    this.applicationForm = this.fb.group({
      name: ['', [Validators.required]], 
      description: ['', [Validators.required]], 
      m_value: ['', [Validators.required]], 
      sp_name: ['', [Validators.required]],
      website: ['', [Validators.required]], 
      email: ['', [Validators.required, Validators.email]], 
      market: ['', [Validators.required]], 
      contact: ['', [Validators.required]], 
      amount: ['', [Validators.required]],
      category: ['', [Validators.required]], 
      location: ['', [Validators.required]], 
      date: ['', [Validators.required]], 
      duration: ['', [Validators.required]], 
      attendance: ['', [Validators.required]],   
      period: ['', [Validators.required]]
    }); 
  }

  ngOnInit(): void {
  }
  
  apply() {
    console.log("apply method() called !!!")
  }

  

}
